import { IconProps } from "./icon.type";

export function IcNotFoundPage(props: IconProps) {
  return (
    <svg
      width="320"
      height="290"
      viewBox="0 0 320 290"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="320" height="290" fill="white" />
      <path
        d="M30 242.859C30 242.859 60.6419 255.486 82.2343 244.669L90.3578 203.252L30 242.859Z"
        fill="#026EEE"
      />
      <path
        d="M66.9133 225.728C66.9133 225.728 83.9179 228.422 84.423 233.388L100.249 232.925L144.402 187.888L140.782 177.997H99.3651L66.9133 225.728Z"
        fill="black"
      />
      <path
        d="M123.651 154.553L78.6145 241.049L93.0515 249.13L138.088 159.982L123.651 154.553Z"
        fill="white"
      />
      <path
        d="M93.3041 250.014L77.7727 241.301L123.357 153.795L138.972 159.646L93.3041 250.014ZM79.4563 240.796L92.7569 248.288L137.162 160.319L123.946 155.353L79.4563 240.796Z"
        fill="black"
      />
      <path
        d="M130.772 157.788L127.878 158.038L129.039 171.457L131.932 171.207L130.772 157.788Z"
        fill="black"
      />
      <path
        d="M108.775 186.383L108.371 189.259L121.71 191.13L122.113 188.254L108.775 186.383Z"
        fill="black"
      />
      <path
        d="M121.968 179.218C123.02 179.218 123.862 178.376 123.862 177.324C123.862 176.271 123.02 175.43 121.968 175.43C120.915 175.43 120.074 176.271 120.074 177.324C120.074 178.376 120.958 179.218 121.968 179.218Z"
        fill="black"
      />
      <path
        d="M104.458 199C104.458 198.032 103.658 197.232 102.69 197.232C101.722 197.232 100.922 198.032 100.922 199C100.922 199.968 101.722 200.768 102.69 200.768C103.658 200.768 104.458 200.01 104.458 199Z"
        fill="black"
      />
      <path
        d="M90.6104 246.352L92.1256 244.542L81.3925 235.745L80.2561 237.892L90.6104 246.352Z"
        fill="black"
      />
      <path
        d="M100.67 234.02L101.386 232.588L83.5812 231.536L82.8236 232.967L100.67 234.02Z"
        fill="black"
      />
      <path
        d="M119.863 196.012L118.39 196.854L108.288 195.002L107.867 197.317L115.191 198.706L94.4405 210.701L92.1676 215.037L104.963 225.559L105.637 224.255L93.262 214.111L117.927 199.842L119.863 196.012Z"
        fill="black"
      />
      <path
        d="M30 242.859C30 242.859 30.8839 201.442 49.8246 182.501C68.7653 163.56 77.7306 159.982 94.8615 159.982C111.992 159.982 148.906 164.486 149.79 171.684C150.673 178.881 142.592 187.888 103.869 184.311C103.869 184.311 97.5552 213.143 66.9555 226.654C36.2715 240.123 30 242.859 30 242.859Z"
        fill="#026EEE"
      />
      <path
        d="M142.045 181.869C142.045 181.869 151.599 187.888 149.79 195.086C147.98 202.283 143.476 204.977 143.476 204.977C143.476 204.977 148.864 216.678 137.162 224.802C137.162 224.802 136.279 232.925 126.345 236.503C116.454 240.123 98.4392 237.387 93.0095 233.809C87.6219 230.189 89.3897 222.992 95.7033 221.182C95.7033 221.182 88.5058 207.671 103.827 206.787C103.827 206.787 94.8194 200.473 102.017 194.16C109.214 187.846 141.666 187.846 141.666 187.846L142.045 181.869Z"
        fill="#026EEE"
      />
      <path
        d="M117.969 202.326H116.706C116.706 199.926 115.991 198.117 114.518 196.98C111.361 194.455 105.805 195.717 105.763 195.717L105.468 194.497C105.721 194.455 111.698 193.108 115.317 195.97C117.085 197.401 117.969 199.505 117.969 202.326Z"
        fill="white"
      />
      <path
        d="M114.013 220.382C113.802 217.688 112.792 215.668 111.024 214.363C107.278 211.585 101.343 212.806 101.259 212.848L101.007 211.627C101.259 211.585 107.573 210.281 111.782 213.395C113.844 214.91 115.023 217.268 115.275 220.298L114.013 220.382Z"
        fill="white"
      />
      <path
        d="M105.384 234.735H104.121C104.121 232.799 103.532 231.284 102.311 230.189C99.6597 227.748 94.9456 228.169 94.9035 228.169L94.7772 226.906C94.9877 226.906 100.081 226.443 103.153 229.263C104.626 230.61 105.384 232.462 105.384 234.735Z"
        fill="white"
      />
      <path
        d="M127.019 225.812C107.783 225.812 95.6612 221.855 95.5349 221.813L95.9137 220.635C96.0821 220.677 112.329 225.98 137.12 224.213L137.205 225.475C133.627 225.728 130.26 225.812 127.019 225.812Z"
        fill="white"
      />
      <path
        d="M122.557 208.386C112.371 208.386 103.953 207.418 103.785 207.418L103.911 206.156C104.163 206.198 127.397 208.807 143.35 205.272L143.644 206.492C137.12 207.966 129.418 208.386 122.557 208.386Z"
        fill="white"
      />
      <path
        d="M143.055 171.642C137.247 171.642 133.416 170.463 131.564 168.106C129.839 165.917 130.638 163.518 130.68 163.434L131.859 163.855L131.27 163.644L131.859 163.855C131.817 163.939 131.27 165.707 132.575 167.348C133.964 169.116 137.794 171.052 147.895 170.126L148.022 171.389C146.254 171.557 144.57 171.642 143.055 171.642Z"
        fill="white"
      />
      <path
        d="M148.863 163.602C173.248 163.602 193.016 143.834 193.016 119.449C193.016 95.0644 173.248 75.2964 148.863 75.2964C124.479 75.2964 104.711 95.0644 104.711 119.449C104.711 143.834 124.479 163.602 148.863 163.602Z"
        fill="black"
      />
      <path
        d="M123.904 132.203L132.448 127.278L146.296 138.685L147.222 137.548L133.795 126.478L159.302 111.747L179.337 115.451L179.758 113.094L162.501 109.937L169.825 105.686L168.646 103.623L158.881 109.263L148.779 107.411L148.358 109.726L155.724 111.073L131.817 124.879L115.444 111.41L114.518 112.504L130.47 125.679L122.725 130.14L123.904 132.203Z"
        fill="white"
      />
      <path
        d="M122.77 143.872L122.686 145.301L163.78 147.725L163.865 146.297L122.77 143.872Z"
        fill="white"
      />
      <path
        d="M183.098 116.05L180.191 129.201L183.027 129.828L185.934 116.677L183.098 116.05Z"
        fill="white"
      />
      <path
        d="M125.335 82.115L123.946 88.3444L126.766 88.9758L128.702 80.2209C127.566 80.7681 126.429 81.3995 125.335 82.115Z"
        fill="white"
      />
      <path
        d="M136.955 104.554L134.048 117.705L136.884 118.332L139.791 105.181L136.955 104.554Z"
        fill="white"
      />
      <path
        d="M118.187 126.643L115.294 126.893L116.455 140.312L119.348 140.062L118.187 126.643Z"
        fill="white"
      />
      <path
        d="M149.687 140.549L149.284 143.425L162.622 145.296L163.026 142.42L149.687 140.549Z"
        fill="white"
      />
      <path
        d="M149.285 98.8001L148.882 101.676L162.22 103.547L162.624 100.671L149.285 98.8001Z"
        fill="white"
      />
      <path
        d="M123.586 95.13L123.157 96.4512L145.578 103.725L146.006 102.404L123.586 95.13Z"
        fill="white"
      />
      <path
        d="M141.792 124.429L141.363 125.75L163.784 133.024L164.212 131.703L141.792 124.429Z"
        fill="white"
      />
      <path
        d="M162.501 91.6275C163.553 91.6275 164.395 90.7857 164.395 89.7334C164.395 88.6812 163.553 87.8394 162.501 87.8394C161.448 87.8394 160.607 88.6812 160.607 89.7334C160.607 90.7857 161.448 91.6275 162.501 91.6275Z"
        fill="white"
      />
      <path
        d="M152.778 155.016C151.726 155.016 150.884 155.858 150.884 156.91C150.884 157.962 151.726 158.804 152.778 158.804C153.83 158.804 154.672 157.962 154.672 156.91C154.672 155.858 153.83 155.016 152.778 155.016Z"
        fill="white"
      />
      <path
        d="M108.92 120.838C108.92 119.702 107.994 118.776 106.857 118.776C105.721 118.776 104.795 119.702 104.795 120.838C104.795 121.975 105.721 122.901 106.857 122.901C107.994 122.901 108.92 121.975 108.92 120.838Z"
        fill="white"
      />
      <path
        d="M167.72 124.206C167.72 123.069 166.794 122.143 165.658 122.143C164.521 122.143 163.595 123.069 163.595 124.206C163.595 125.342 164.521 126.268 165.658 126.268C166.794 126.268 167.72 125.342 167.72 124.206Z"
        fill="white"
      />
      <path
        d="M144.949 111.41C144.949 110.442 144.149 109.642 143.181 109.642C142.213 109.642 141.413 110.442 141.413 111.41C141.413 112.378 142.213 113.178 143.181 113.178C144.149 113.178 144.949 112.42 144.949 111.41Z"
        fill="white"
      />
      <path
        d="M105.679 110.442H128.702V108.085H106.226C106.015 108.843 105.847 109.642 105.679 110.442Z"
        fill="white"
      />
      <path
        d="M153.283 78.0743L150.463 77.443L150.084 79.2108L145.496 75.4226C144.823 75.4647 144.149 75.5489 143.476 75.6331L149.747 80.8102L147.601 90.6173L150.421 91.2487L152.273 82.8727L157.282 86.9975L158.208 85.8611L152.652 81.2732L153.283 78.0743Z"
        fill="white"
      />
      <path
        d="M169.53 83.8408L172.392 83.5882L172.266 82.0309C171.256 81.3995 170.245 80.8102 169.193 80.2631L169.53 83.8408Z"
        fill="white"
      />
      <path
        d="M176.643 102.908H188.513L190.407 104.465C189.817 102.823 189.144 101.266 188.386 99.7088L174.665 88.4286L173.15 90.2806L186.871 101.561H176.643V102.908Z"
        fill="white"
      />
      <path
        d="M111.193 142.389L131.143 158.762L132.659 156.91L108.457 137.001C109.214 138.895 110.14 140.663 111.193 142.389Z"
        fill="white"
      />
      <path
        d="M183.546 146.766L180.768 145.84L182.41 143.357L178.958 141.084L176.685 144.493L167.341 141.463L166.92 142.767L175.886 145.672L171.508 152.28L174.96 154.553L179.968 146.976L182.62 147.818C182.915 147.524 183.251 147.145 183.546 146.766Z"
        fill="white"
      />
      <path
        d="M148.864 150.975C166.275 150.975 180.389 136.861 180.389 119.449C180.389 102.038 166.275 87.9236 148.864 87.9236C131.452 87.9236 117.338 102.038 117.338 119.449C117.338 136.861 131.452 150.975 148.864 150.975Z"
        fill="white"
      />
      <path
        d="M141.723 101.433L142.398 109.317L144.411 109.145L143.736 101.26L141.723 101.433Z"
        fill="black"
      />
      <path
        d="M143.435 119.476L147.372 122.292L148.082 121.299L144.145 118.483L143.435 119.476Z"
        fill="black"
      />
      <path
        d="M167.977 116.877L171.485 113.543L170.645 112.658L167.136 115.993L167.977 116.877Z"
        fill="black"
      />
      <path
        d="M160.909 108.06L165.577 101.67L163.946 100.478L159.278 106.868L160.909 108.06Z"
        fill="black"
      />
      <path
        d="M125.369 123.472L124.249 118.763L123.061 119.046L124.182 123.754L125.369 123.472Z"
        fill="black"
      />
      <path
        d="M145.25 138.348L140.415 138.56L140.468 139.779L145.304 139.568L145.25 138.348Z"
        fill="black"
      />
      <path
        d="M156.44 116.966C157.021 116.966 157.492 116.495 157.492 115.914C157.492 115.333 157.021 114.861 156.44 114.861C155.859 114.861 155.388 115.333 155.388 115.914C155.388 116.495 155.859 116.966 156.44 116.966Z"
        fill="black"
      />
      <path
        d="M182.073 52.0624L185.903 60.228L186.913 59.0495L183.925 50L182.073 52.0624Z"
        fill="black"
      />
      <path
        d="M202.192 74.2021C203.052 74.2021 203.75 73.5048 203.75 72.6447C203.75 71.7846 203.052 71.0874 202.192 71.0874C201.332 71.0874 200.635 71.7846 200.635 72.6447C200.635 73.5048 201.332 74.2021 202.192 74.2021Z"
        fill="black"
      />
      <path
        d="M76.51 149.456L72.0484 125.675L31.4732 133.251L30 125.465L58.5374 62.4132L71.2908 60.014L81.4346 114.311L93.6408 112.038L95.3665 121.298L83.1603 123.571L87.6219 147.352L76.51 149.456ZM70.3227 116.415L64.8509 87.2466C64.0091 82.6587 63.2936 78.0709 62.7043 73.483L62.2834 73.5672C60.5577 79.1652 59.0845 83.3322 57.443 87.8358L41.617 121.508L41.6591 121.761L70.3227 116.415Z"
        fill="black"
      />
      <path
        d="M238.264 156.401L243.904 132.873L203.75 123.234L205.602 115.531L257.373 69.6107L270 72.6412L257.12 126.349L269.2 129.253L267.012 138.429L254.932 135.524L249.291 159.053L238.264 156.401ZM246.093 123.739L253.037 94.907C254.132 90.4034 255.352 85.8997 256.699 81.4381L256.321 81.3539C252.448 85.7734 249.418 88.9723 246.093 92.3816L217.892 116.668L217.808 116.92L246.093 123.739Z"
        fill="black"
      />
    </svg>
  );
}
